import React, { Component } from 'react'
import CountUp from 'react-countup';
import BannerNewsEvent from './BannerNewsEvent'
import SectionTitleOne from './SectionTitleOne'
import Appointment from './Appointment';
import BlogOne from './Blog/BlogOne';

import BlogData from './Data/BlogData';
import Qulification from './Qulification'
import SleepNews from './SleepNews'
import GalleryImage from './GalleryImage';
import NewsPublished from './NewsPublished';
import CoursesComponent from './CoursesComponent';

import { Helmet } from 'react-helmet';

class NewsEvents extends Component {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <meta charSet='utf-8' />
                    <title>Latest News & Events | Sleep Therapeutics India</title>
                    <meta name='description' content="Stay updated with the latest news and events from Sleep Therapeutics. Discover insights and innovations in sleep health. Learn More!" />
                </Helmet>
                <BannerNewsEvent pageTitle='News & Events' />

                <section className="about-page-top-content-wrap section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-md-12 col-lg-8 offset-lg-2 text-center">
                                <div className="section-text-wrap">
                                    <h1>News & Events at Sleep Therapeutics</h1>
                                    <p>Stay updated with the latest news and events from the world of Sleep Therapeutics. Whether it's a discovery, an event, a dignitary visit, an introduction of new services, our media coverage, etc., find it all here.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <CoursesComponent />
                <SleepNews />
                <NewsPublished />
                <GalleryImage />
                {/* <Appointment appointmentTitle={"We’re a message away."}  /> */}

            </React.Fragment>
        )
    }
}

export default NewsEvents
